import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import {
  selectActiveWell,
  selectDeclinePhase,
} from "features/decline_analysis/dcaProjectSlice";
import { getDcaDiagnostics } from "service/dcaAnalysis";

import DcaDiagnosticsChart from "components/charts/DcaDiagnosticsChart";

// DCA-C3 diagnostic view ("diagnose before you fit"). Positioned as a
// diagnostic tab/view of the Decline Analyzer: it reads the active well +
// decline phase from the dca_project slice, pulls the flow-regime diagnostics
// from BE, and renders the log-log (with slope reference lines) + rate-cum
// charts with regime annotations. Does NOT touch ForecastChart / params panel.
//
// Endpoint-not-ready is handled in the service (resolves null); we additionally
// hold a `loaded` flag so the chart shows the right empty-state copy.
function DcaDiagnostics(props) {
  const { loadingIconActions } = props;
  const [showLoadingIcon, hideLoadingIcon] = loadingIconActions || [];

  const activeWell = useSelector(selectActiveWell);
  const declinePhase = useSelector(selectDeclinePhase);

  const [diagData, setDiagData] = useState(null);

  const reload = useCallback(
    (wellId, phase) => {
      showLoadingIcon && showLoadingIcon();
      getDcaDiagnostics(
        { wellId, phase },
        (result) => {
          setDiagData(result); // null on degrade -> chart shows empty state
          hideLoadingIcon && hideLoadingIcon();
        },
        () => {
          // already degraded to null via service; nothing to do
          hideLoadingIcon && hideLoadingIcon();
        }
      );
    },
    [showLoadingIcon, hideLoadingIcon]
  );

  useEffect(() => {
    const wellId = activeWell?.uwi;
    if (!wellId) {
      setDiagData(null);
      return;
    }
    reload(wellId, declinePhase);
  }, [activeWell, declinePhase, reload]);

  return (
    <div className="cards-container h-100">
      <div className="cards-header d-flex flex-row justify-content-between align-items-center">
        <span className="header-title">Flow-Regime Diagnostics</span>
        <span style={{ color: "#999", fontSize: 12 }}>
          diagnose before you fit
        </span>
      </div>
      <div
        className="cards-content d-flex flex-column"
        style={{ minHeight: 0, flex: 1 }}
      >
        <DcaDiagnosticsChart
          data={diagData}
          title={activeWell?.well_name || activeWell?.uwi}
        />
      </div>
    </div>
  );
}

export default DcaDiagnostics;
